import {
  HasuraDataTableColumnDef,
  DataTableEx,
  DataTableExProps,
  DataTableExRef,
  AttachmentsZone,
} from '@kirz/mui-admin';
import { Box, Button } from '@mui/material';
import React, {
  forwardRef,
  Ref,
  useContext,
  useImperativeHandle,
  useMemo,
  useRef,
} from 'react';

import { UserContext } from 'contexts/UserContext';

export const DocumentsTable = forwardRef(
  (
    props: Partial<DataTableExProps> & {
      id: string;
      attachmentType: string;
      filterColumns?: (
        columns: HasuraDataTableColumnDef[],
      ) => HasuraDataTableColumnDef[];
    },
    ref: Ref<DataTableExRef>,
  ) => {
    const { user } = useContext(UserContext);
    const { filterColumns, attachmentType, ...rest } = props;
    const tableRef = useRef<DataTableExRef>(null);

    useImperativeHandle(ref, () => tableRef.current!, []);

    const columns = useMemo<HasuraDataTableColumnDef[]>(
      () =>
        (filterColumns || ((x: HasuraDataTableColumnDef[]) => x))([
          {
            field: 'name',
            headerName: 'Naam',
            selector: 'publicId name extension',
            flex: 1,
            onSort(sort) {
              return [{ name: sort }];
            },
            renderCell: (params) => {
              const { name, extension } = params.row;

              return (
                <Box
                  component="a"
                  href={`/api/v1/files/${params.row.publicId}`}
                  target="_blank"
                  sx={{ color: 'inherit' }}
                >
                  {name}
                  {extension}
                </Box>
              );
            },
          },
          { field: 'createdAt', headerName: 'Gemaakt op', type: 'date' },
          {
            field: 'download',
            headerName: '',
            selector: false,
            sortable: false,
            width: 150,
            renderCell: (params) => {
              return (
                <Button
                  variant="contained"
                  size="small"
                  component="a"
                  href={`/api/v1/files/${params.row.publicId}/${params.row.name}${params.row.extension}`}
                  target="_blank"
                  download
                >
                  Download
                </Button>
              );
            },
            flex: 1,
          },
        ]),
      [filterColumns],
    );

    return (
      <DataTableEx
        {...rest}
        ref={tableRef}
        source="file"
        columns={columns}
        persistStateMode="query"
        sortBy={rest.sortBy ?? { field: 'createdAt', sort: 'desc' }}
        editable={{
          icon: 'eye',
          onEdit(row) {
            window.open(`/api/v1/files/${row.publicId}`, '_blank');
          },
        }}
        formTitle={(isNew) => (isNew ? 'Nieuw document' : 'Edit document')}
        formDialogProps={{
          ...rest.formDialogProps,
          maxWidth: 'sm',
          onClose: () => {
            tableRef.current?.reload();
          },
          components: {
            ActionButtons(props) {
              return <Button onClick={props.handleClose}>Close</Button>;
            },
          },
        }}
        selectProps={{
          filter: {
            clientId: { _eq: user?.id },
            attachmentType: { _eq: attachmentType },
            companyId: { _isNull: true },
          },
        }}
      >
        {/* <FormInput name="name" label="Name" md={12} required /> */}
        <AttachmentsZone
          value={[]}
          name="clientId"
          entityId={user?.id}
          attachmentsTypes={[{ value: attachmentType, text: attachmentType }]}
          dropzoneProps={{}}
        />
      </DataTableEx>
    );
  },
);
